import { render, staticRenderFns } from "./Transact.vue?vue&type=template&id=0bf492bb&scoped=true&"
import script from "./Transact.vue?vue&type=script&lang=js&"
export * from "./Transact.vue?vue&type=script&lang=js&"
import style0 from "./Transact.vue?vue&type=style&index=0&id=0bf492bb&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf492bb",
  null
  
)

export default component.exports